import { MEDICAL_PATHS } from "../../api/endpoints";

const persistedId = (item = {}) => {
  const candidate = item.backendId ?? item.id;
  return /^\d+$/.test(String(candidate ?? "").trim()) ? candidate : null;
};

const versionConfig = (item = {}) => ({
  headers: { "X-Resource-Version": String(item.version ?? 1) },
});

const dateFromYear = (value) => {
  if (value === null || value === undefined || String(value).trim() === "") {
    return undefined;
  }

  const text = String(value).trim();
  return /^\d{4}-\d{2}-\d{2}$/.test(text) ? text : `${text}-01-01`;
};

export const buildAllergyMutation = (patientId, allergy = {}) => {
  const id = persistedId(allergy);
  const body = {
    item: String(allergy.label ?? allergy.item ?? "").trim(),
    reaction: String(allergy.severity ?? allergy.reaction ?? "").trim(),
  };

  return id
    ? {
        method: "put",
        url: MEDICAL_PATHS.UPDATE_SURGICAL_HISTORY(patientId, id),
        body,
        config: versionConfig(allergy),
      }
    : {
        method: "post",
        url: MEDICAL_PATHS.SURGICAL_HISTORY(patientId),
        body: { type: "ALLERGY", ...body },
      };
};

export const buildSurgeryMutation = (patientId, surgery = {}) => {
  const id = persistedId(surgery);
  const date = dateFromYear(surgery.year ?? surgery.date);
  const body = {
    item: String(surgery.label ?? surgery.item ?? "").trim(),
    ...(date ? { date } : {}),
  };

  return id
    ? {
        method: "put",
        url: MEDICAL_PATHS.UPDATE_SURGICAL_HISTORY(patientId, id),
        body,
        config: versionConfig(surgery),
      }
    : {
        method: "post",
        url: MEDICAL_PATHS.SURGICAL_HISTORY(patientId),
        body: { type: "SURGERY", ...body },
      };
};

export const buildVaccinationMutation = (patientId, vaccination = {}) => {
  const id = persistedId(vaccination);
  const date = dateFromYear(vaccination.year ?? vaccination.date);
  const body = {
    vaccine: String(
      vaccination.label ?? vaccination.vaccine ?? vaccination.vaccineName ?? "",
    ).trim(),
    ...(date ? { date } : {}),
  };

  return id
    ? {
        method: "put",
        url: MEDICAL_PATHS.UPDATE_VACCINATION(patientId, id),
        body,
        config: versionConfig(vaccination),
      }
    : {
        method: "post",
        url: MEDICAL_PATHS.VACCINATIONS(patientId),
        body,
      };
};

export const executeOverviewMutation = (client, mutation) =>
  client[mutation.method](mutation.url, mutation.body, mutation.config);
